export enum AppName {
  AionAlertUI = 'aion-alert-ui',
  AionBackOfficeUI = 'aion-backoffice-ui',
  AionConnectUI = 'aion-connect-ui',
  AionEmployeeUI = 'aion-employee-ui',
  AionEsignatureUI = 'aion-esignature-ui',
  AionLinksUI = 'aion-links-ui',
  AionQualificationUI = 'aion-qualification-ui',
  AionSMARTUI = 'aion-smart-ui',
  AionSubscriberUI = 'aion-subscriber-ui',
  AionRegionMetricUI = 'aion-regionmetric-ui',
  AionReportingUI = 'aion-reporting-ui',
  AionSafetyProgramsUI = 'aion-safetyprograms-ui',
  AionScoringUI = 'aion-scoring-ui',
  AionVeriforceIntegrationUI = 'aion-veriforce-integration-ui',
  AionTrainingComplianceUI = 'aion-training-compliance-ui',
  AionOshaViolationsUI = 'aion-osha-violations-ui',
  AionSubcontractorManagementUI = 'aion-subcontractor-management-ui',
  AionOrganizationProfileUI = 'aion-organization-profile-ui',
  AionQuestionnaireBuilderUI = 'aion-questionnaire-builder-ui',
  AionQuestionnaireUI = 'aion-questionnaire-ui',
  AionPreQualificationGroupsUI = 'aion-prequalification-groups-ui',
  AionProcessAutomationUI = 'aion-process-automation-ui',
  AionQuestionnaireDocumentsUI = 'aion-questionnaire-documents-ui',
  AionActivityFeedUI = 'aion-activity-feed-ui',
  AionTranslationManagementUI = 'aion-translation-management-ui'
}
